(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("classnames"), require("prop-types"), require("react"));else if (typeof define === 'function' && define.amd) define(["classnames", "prop-types", "react"], factory);else {
    var a = typeof exports === 'object' ? factory(require("classnames"), require("prop-types"), require("react")) : factory(root["classnames"], root["prop-types"], root["react"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 3);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
      /***/
    },
    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _Cell = __webpack_require__(4);

      Object.defineProperty(exports, 'Cell', {
        enumerable: true,
        get: function get() {
          return _interopRequireDefault(_Cell).default;
        }
      });

      var _Grid = __webpack_require__(5);

      Object.defineProperty(exports, 'Grid', {
        enumerable: true,
        get: function get() {
          return _interopRequireDefault(_Grid).default;
        }
      });

      var _Row = __webpack_require__(6);

      Object.defineProperty(exports, 'Row', {
        enumerable: true,
        get: function get() {
          return _interopRequireDefault(_Row).default;
        }
      });

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }
      /***/

    },
    /* 4 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _classnames2 = __webpack_require__(0);

      var _classnames3 = _interopRequireDefault(_classnames2);

      var _propTypes = __webpack_require__(1);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _react = __webpack_require__(2);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      var Cell = function Cell(props) {
        var _classnames;

        var align = props.align,
            children = props.children,
            className = props.className,
            columns = props.columns,
            desktopColumns = props.desktopColumns,
            order = props.order,
            phoneColumns = props.phoneColumns,
            tabletColumns = props.tabletColumns,
            Tag = props.tag,
            otherProps = _objectWithoutProperties(props, ['align', 'children', 'className', 'columns', 'desktopColumns', 'order', 'phoneColumns', 'tabletColumns', 'tag']);

        var classes = (0, _classnames3.default)('mdc-layout-grid__cell', className, (_classnames = {}, _defineProperty(_classnames, 'mdc-layout-grid__cell--align-' + align, !!align), _defineProperty(_classnames, 'mdc-layout-grid__cell--order-' + order, !!order), _defineProperty(_classnames, 'mdc-layout-grid__cell--span-' + columns, !!columns), _defineProperty(_classnames, 'mdc-layout-grid__cell--span-' + desktopColumns + '-desktop', !!desktopColumns), _defineProperty(_classnames, 'mdc-layout-grid__cell--span-' + phoneColumns + '-phone', !!phoneColumns), _defineProperty(_classnames, 'mdc-layout-grid__cell--span-' + tabletColumns + '-tablet', !!tabletColumns), _classnames));
        return _react2.default.createElement(Tag, _extends({
          className: classes
        }, otherProps), children);
      };

      Cell.propTypes = {
        align: _propTypes2.default.oneOf(['bottom', 'middle', 'top']),
        children: _propTypes2.default.node,
        className: _propTypes2.default.string,
        columns: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
        desktopColumns: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
        order: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
        phoneColumns: _propTypes2.default.oneOf([1, 2, 3, 4]),
        tabletColumns: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
        tag: _propTypes2.default.string
      };
      Cell.defaultProps = {
        align: undefined,
        children: undefined,
        className: '',
        columns: undefined,
        desktopColumns: undefined,
        order: undefined,
        phoneColumns: undefined,
        tabletColumns: undefined,
        tag: 'div'
      };
      exports.default = Cell;
      /***/
    },
    /* 5 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _classnames2 = __webpack_require__(0);

      var _classnames3 = _interopRequireDefault(_classnames2);

      var _propTypes = __webpack_require__(1);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _react = __webpack_require__(2);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      var Grid = function Grid(props) {
        var _classnames;

        var align = props.align,
            children = props.children,
            className = props.className,
            fixedColumnWidth = props.fixedColumnWidth,
            Tag = props.tag,
            otherProps = _objectWithoutProperties(props, ['align', 'children', 'className', 'fixedColumnWidth', 'tag']);

        var classes = (0, _classnames3.default)('mdc-layout-grid', className, (_classnames = {}, _defineProperty(_classnames, 'mdc-layout-grid--align-' + align, !!align), _defineProperty(_classnames, 'mdc-layout-grid--fixed-column-width', fixedColumnWidth), _classnames));
        return _react2.default.createElement(Tag, _extends({
          className: classes
        }, otherProps), children);
      };

      Grid.propTypes = {
        align: _propTypes2.default.oneOf(['left', 'right']),
        children: _propTypes2.default.node.isRequired,
        className: _propTypes2.default.string,
        fixedColumnWidth: _propTypes2.default.bool,
        tag: _propTypes2.default.string
      };
      Grid.defaultProps = {
        align: undefined,
        className: '',
        fixedColumnWidth: false,
        tag: 'div'
      };
      exports.default = Grid;
      /***/
    },
    /* 6 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _classnames = __webpack_require__(0);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _propTypes = __webpack_require__(1);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _react = __webpack_require__(2);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      var Row = function Row(props) {
        var children = props.children,
            className = props.className,
            Tag = props.tag,
            otherProps = _objectWithoutProperties(props, ['children', 'className', 'tag']);

        var classes = (0, _classnames2.default)('mdc-layout-grid__inner', className);
        return _react2.default.createElement(Tag, _extends({
          className: classes
        }, otherProps), children);
      };

      Row.propTypes = {
        children: _propTypes2.default.node.isRequired,
        className: _propTypes2.default.string,
        tag: _propTypes2.default.string
      };
      Row.defaultProps = {
        className: '',
        tag: 'div'
      };
      exports.default = Row;
      /***/
    }])
  );
});